/* eslint-disable */
import ApiService from '@/services/Base/ApiService';

const getDefaultState = () => {
  return {
    originalResults: null,
    groupedResults: null,
    uiResults: null,
    geoJson: [],

    savedUiDetails: {},
    showAllEra: false,

    isOpenedPeriodicalDetail: false,
    openedPeriodicalDetail: { id: 0, },
    openedPeriodicalDetails: {},

    allDetails: null,
  }
}

const state = getDefaultState()

const getters = {
  getOriginalResults(state) {
    return state.originalResults;
  },
  getGroupedResults(state) {
    return state.groupedResults;
  },
  getUiResults(state) {
    return state.uiResults;
  },

  getGeoJson(state) {
    return state.geoJson;
  },
}

const mutations = {
  setOriginalResults(state, data) {
    state.originalResults = data;
  },
  setGroupedResults(state, data) {
    state.groupedResults = data;
  },
  setUiResults(state, data) {
    state.uiResults = data;
  },

  setGeoJson(state, data) {
    state.geoJson = data;
  },
}

const actions = {
  async fetchSupervisedPeriodDetails({ state }, groupedSourceCodes) {
    try {
      if (!groupedSourceCodes) {
        return;
      }
      const saveDetail = state.savedUiDetails[groupedSourceCodes.join(',')]
      if (saveDetail) {
        return saveDetail;
      } else {
        state.allDetails = (state.allDetails ?? await ApiService.get('SupervisedPeriodDetail'));
        if (state.allDetails.statusCode === 200) {
          const filtered = state.allDetails.result.filter(x => groupedSourceCodes.includes(x.sourceCode));
          state.savedUiDetails[groupedSourceCodes.join(',')] = filtered;
          return filtered;
        } else {
          throw error;
        }
      }
      
    } catch (error) {
      throw error;
    }
  },

  async fetchSupervisedPeriodDetail(context, id) {
    try {
      const findDetail = context.state.openedPeriodicalDetails[id];
      if (findDetail) {
        context.state.openedPeriodicalDetail = findDetail;
        return findDetail;
      }

      const response = await ApiService.get(`SupervisedPeriodDetail/${id}`);
      if (response.statusCode === 200) {
        context.state.openedPeriodicalDetail = response.result;
        context.state.openedPeriodicalDetails[id] = response.result;
        return response.result;
      } else {
        throw error;
      }
      
    } catch (error) {
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
